const defaultData = {
  id: '', // this needs to be unique when passed in
  parentName: 'slotContainer:winPopupTextContainer',
  yOffset: -100,
  reel: -1,
  row: -1,
  containerData: {
    pivot: { x: 75, y: 50 },
  },
  textData: {
    ID: '',
    type: 'text',
    fontDefinition: 'Font_White',
    anchor: 0.5,
    maxWidth: 130,
    maxHeight: 100,
    fontOverrides: { fontSize: 40, strokeThickness: 3, dropShadow: true, wordWrapWidth: 130 },
  },
};

WinTextPopup = function (data) {
  // constructor!
  this.data = _.merge({}, defaultData, data);
  this.value = 0;
  this.row = -1;
  this.reel = -1;
  this._emptyArray = [];
  this.scaleUpTweenInfo = {};
  this.fadeInTweenInfo = {};
  this.moveTweenInfo = {};
  this.scaleTweenInfo = {};
  this.fadeTweenInfo = {};
  this.skipped = false;

  this.winTextParent = resourceManager.get(this.data.parentName);
  // we need a container to scale, as if we scale the text in a tween, it undoes all the resize!!
  this.winTextContainer = this.createContainer();
  this.winText = this.createText();
  // remove from parent until needed!
  this.winTextParent.removeChild(this.winText);
  // reparent to our container, which we will be scaling and moving etc
  this.winTextContainer.addChild(this.winText);
};

WinTextPopup.prototype.createContainer = function () {
  const container = new PIXI.Container();
  return container;
};

WinTextPopup.prototype.createText = function () {
  const text = resourceManager.createObject(
    'text',
    this.data.id, //
    this.data.parentName,
    this.data.textData
  );

  return text;
};

WinTextPopup.prototype.getRow = function () {
  return this.data.row;
};

WinTextPopup.prototype.getReel = function () {
  return this.data.reel;
};

WinTextPopup.prototype.setXY = function (x, y) {
  this.winTextContainer.position.set(x, y);
  // this.winText.position.set(x, y);
};

WinTextPopup.prototype.setValue = function (value, isCapped = false) {
  this.value = value;
  let text = '';
  isCapped = false; // we arent worried about the value being shown here
  if (isCapped) {
    text = gdk.translateText('t_maxWin', this._emptyArray);
  } else {
    text = gdk.formatCurrency(value);
  }
  this.winText.setText(text);
};

WinTextPopup.prototype.show = async function () {
  // assume
  // text already set
  // position already set
  // not on the container

  this.skipped = false;

  this.winTextParent.addChild(this.winTextContainer);
  this.winTextContainer.alpha = 0;
  this.winTextContainer.scale.set(0, 0);

  const scaleUpPromise = game.tweenFromToAsync(
    this.winTextContainer.scale,
    {
      x: 0,
      y: 0,
    },
    {
      x: 1.15,
      y: 1.15,
      duration: 0.25,
      ease: 'power1.out',
    },
    this.scaleUpTweenInfo
  );

  const fadeInPromise = game.tweenFromToAsync(
    this.winTextContainer,
    {
      alpha: 0,
    },
    {
      alpha: 1,
      duration: 0.25,
      ease: 'power1.out',
    },
    this.fadeInTweenInfo
  );

  // move the value up
  const movePromise = game.tweenFromToAsync(
    this.winTextContainer,
    {
      x: this.winTextContainer.x,
      y: this.winTextContainer.y,
    },
    {
      x: this.winTextContainer.x,
      y: this.winTextContainer.y + this.data.yOffset,
      duration: 1.5,
      ease: 'sine.out',
    },
    this.moveTweenInfo
  );

  await Promise.all([scaleUpPromise, fadeInPromise]);

  // all these tweens may need to start at the same time, but have delays and
  // immediateRender: false
  // there is a small window of when you skip, as the tweens are being created
  if (this.skipped === false) {
    const scalePromise = game.tweenFromToAsync(
      this.winTextContainer.scale,
      {
        x: 1.15,
        y: 1.15,
      },
      {
        x: 0.9,
        y: 0.9,
        duration: 1.5,
        ease: 'power1.out',
      },
      this.scaleTweenInfo
    );

    // half way through, fade out
    const fadePromise = game.tweenFromToAsync(
      this.winTextContainer,
      {
        alpha: 1,
      },
      {
        alpha: 0,
        delay: 0.75,
        duration: 0.75,
        ease: 'power1.out',
      },
      this.fadeTweenInfo
    );
    await Promise.all([scalePromise, movePromise, fadePromise]);
  } else {
    // skipped
  }

  this.winTextParent.removeChild(this.winTextContainer);
};

WinTextPopup.prototype.skip = function () {
  if (this.skipped === false) {
    this.skipped = true;

    if (this.scaleUpTweenInfo.tween) {
      if (this.scaleUpTweenInfo.tween.isActive() === true) {
        this.scaleUpTweenInfo.tween.progress(1);
      }
    }

    if (this.fadeInTweenInfo.tween) {
      if (this.fadeInTweenInfo.tween.isActive() === true) {
        this.fadeInTweenInfo.tween.progress(1);
      }
    }

    if (this.moveTweenInfo.tween) {
      if (this.moveTweenInfo.tween.isActive() === true) {
        this.moveTweenInfo.tween.progress(1);
      }
    }

    let scaleTweenWasActive = false;
    if (this.scaleTweenInfo.tween) {
      if (this.scaleTweenInfo.tween.isActive() === true) {
        scaleTweenWasActive = true;
        this.scaleTweenInfo.tween.progress(1);
      }
    }

    if (this.fadeTweenInfo.tween) {
      if (this.fadeTweenInfo.tween.isActive() === true) {
        this.fadeTweenInfo.tween.progress(1);
      } else {
        if (scaleTweenWasActive === true) {
          // still in the delay part of the fadeTween
          // which means isActive will return false
          this.fadeTweenInfo.tween.progress(1);
        }
      }
    }
  }
};
